import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { Card, Message } from '@weezevent/nacre';

import EventCreationInfos from '../../event_creation/eventCreationInfos';
import { initLanguage, handleTranslations } from '../../event_creation/translationsUtils';

export default function DescriptionForm({
    event,
    formEvent,
    onChange,
    onChangeObject,
    taxes,
    organization,
    isSubmitting,
    eventSubtypes,
    id = 'event-form-description',
    defaultLanguage,
    languageOptions,
}) {
    const { t } = useTranslation();

    const subtypesOptions = React.useMemo(() => {
        return eventSubtypes?.map(subtype => ({ text: subtype.label, value: subtype.type, external_id: subtype.id_weez }));
    }, [eventSubtypes]);

    const initLanguageEvent = React.useCallback(
        (value, name) => initLanguage(value, name, formEvent, onChangeObject),
        [formEvent, onChangeObject]
    );

    const handleTranslationsEvent = React.useCallback(
        (value, property, selectedLanguage) => handleTranslations(value, property, selectedLanguage, formEvent, onChangeObject, defaultLanguage, event?.translations),
        [onChangeObject, formEvent, defaultLanguage, event]
    );

    return (
        <Card.FormStep
            title={t('ticket.event.description')}
            subtitle={t('ticket.event.edit.infoSubtitle')}
            rightComponent={
                <Message type="tips" title={t('ticket.common.tips')} mini>
                    <Trans i18nKey={`ticket.event.edit.infoTips`} />
                </Message>
            }
            id={id}
        >
            <EventCreationInfos
                formEvent={formEvent}
                organization={organization}
                onChange={onChange}
                isSubmitting={isSubmitting}
                onChangeObject={info => onChangeObject(info, true)}
                subtypesOptions={subtypesOptions}
                edit={true}
                taxes={taxes}
                defaultLanguage={defaultLanguage}
                languageOptions={languageOptions}
                initLanguage={initLanguageEvent}
                handleTranslations={handleTranslationsEvent}
            />
        </Card.FormStep>
    );
}

DescriptionForm.propTypes = {
    formEvent: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeObject: PropTypes.func.isRequired,
    taxes: PropTypes.array.isRequired,
    organization: PropTypes.object.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    eventSubtypes: PropTypes.array.isRequired
}